import React from "react";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { SF } from "../../constants/testIds";

function Field({ label, children, full }) {
    return (
        <div className={full ? "sm:col-span-2" : ""}>
            <Label className="text-sm">{label}</Label>
            <div className="mt-2">{children}</div>
        </div>
    );
}

export function ShippingAddressFields({ addr, onChange }) {
    const set = (patch) => onChange({ ...addr, ...patch });
    return (
        <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Address line 1" full>
                <Input data-testid={SF.formAddrLine1} value={addr.line1} onChange={(e) => set({ line1: e.target.value })} className="h-12 bg-muted/40" />
            </Field>
            <Field label="City">
                <Input data-testid={SF.formAddrCity} value={addr.city} onChange={(e) => set({ city: e.target.value })} className="h-12 bg-muted/40" />
            </Field>
            <Field label="State / region">
                <Input data-testid={SF.formAddrState} value={addr.state} onChange={(e) => set({ state: e.target.value })} className="h-12 bg-muted/40" />
            </Field>
            <Field label="Postal code">
                <Input data-testid={SF.formAddrZip} value={addr.postal_code} onChange={(e) => set({ postal_code: e.target.value })} className="h-12 bg-muted/40" />
            </Field>
            <Field label="Country">
                <Input data-testid={SF.formAddrCountry} value={addr.country} onChange={(e) => set({ country: e.target.value })} className="h-12 bg-muted/40" />
            </Field>
        </div>
    );
}
